import { Box, Button, ButtonProps, Skeleton, useTheme } from "@mui/material";
import { Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { toolbarPlugin } from "@react-pdf-viewer/toolbar";
import "@react-pdf-viewer/toolbar/lib/styles/index.css";

export interface DocumentPreviewProps {
  fileUrl: string;
  bottomLeftButtonProps?: ButtonProps & {
    text: string;
    toolTipText?: string;
  };
}

export const DocumentPreview = ({
  fileUrl,
  bottomLeftButtonProps,
}: DocumentPreviewProps) => {
  const toolbarPluginInstance = toolbarPlugin();
  const { Toolbar } = toolbarPluginInstance;
  const theme = useTheme();

  return (
    <Box
      className="rpv-core__viewer"
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        border: `1px solid ${theme.palette.divider}`,
      }}
    >
      <Box
        sx={{
          alignItems: "center",
          bgcolor: theme.palette.grey50.main,
          borderBottom: `1px solid ${theme.palette.divider}`,
          display: "flex",
          padding: "4px",
        }}
      >
        <Toolbar>
          {(props) => {
            const {
              CurrentPageInput,
              GoToNextPage,
              GoToPreviousPage,
              NumberOfPages,
              ShowSearchPopover,
              Zoom,
              ZoomIn,
              ZoomOut,
            } = props;
            return (
              <>
                <div style={{ padding: "0px 2px" }}>
                  <ShowSearchPopover />
                </div>
                <div style={{ padding: "0px 2px" }}>
                  <ZoomOut />
                </div>
                <div style={{ padding: "0px 2px" }}>
                  <Zoom />
                </div>
                <div style={{ padding: "0px 2px" }}>
                  <ZoomIn />
                </div>
                <div style={{ padding: "0px 2px", marginLeft: "auto" }}>
                  <GoToPreviousPage />
                </div>
                <div className="rpv-toolbar__item">
                  <CurrentPageInput />
                </div>
                <span className="rpv-toolbar__label">
                  / <NumberOfPages />
                </span>
                <div style={{ padding: "0px 2px" }}>
                  <GoToNextPage />
                </div>
              </>
            );
          }}
        </Toolbar>
      </Box>
      <Box sx={{ height: "calc(100% - 43px)", position: "relative" }}>
        {fileUrl && (
          <Viewer
            fileUrl={fileUrl}
            plugins={[toolbarPluginInstance]}
            renderError={() => (
              <Box sx={{ p: 2 }}>Document preview only displays for PDFs.</Box>
            )}
            renderLoader={() => (
              <Skeleton
                variant="rectangular"
                animation="wave"
                height="100%"
                width="100%"
                sx={{
                  borderRadius: theme.spacing(0.5),
                }}
              />
            )}
          />
        )}
        {bottomLeftButtonProps && (
          <Button
            variant="contained"
            {...bottomLeftButtonProps}
            sx={{
              position: "absolute",
              bottom: 16,
              left: 16,
              zIndex: 1,
              ...bottomLeftButtonProps.sx,
            }}
          >
            {bottomLeftButtonProps.text}
          </Button>
        )}
      </Box>
    </Box>
  );
};
